import { IQuotesDetail } from '../../../../services/serviceInvoice/responseInterfaces';

export const getSumForBillingAmount = (data: IQuotesDetail[]): number => {
  let sum: number = 0;
  data.forEach((item:IQuotesDetail) => {
    sum += item.price;
  });
  return sum;
};
